"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TextInput = require("../../components/TextInput");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var TextInput = {
  styles: function styles(theme) {
    return {
      input: {
        borderRadius: 4,
        padding: "".concat(theme.spacing.base, "px ").concat(theme.spacing.base * 1.5, "px"),
        fontSize: theme.typography.fontSize + 2,
        borderColor: theme.colors.baseContrast020,
        "&::placeholder": {
          color: theme.colors.baseContrast050
        },
        "&:focus-visible": {
          borderColor: theme.colors.baseContrast080,
          boxShadow: "none"
        }
      },
      preAndSuffix: {
        borderColor: theme.colors.baseContrast030,
        backgroundColor: theme.colors.baseContrast020,
        color: theme.colors.baseContrast100
      },
      prefix: {
        borderEndStartRadius: "4px",
        borderStartStartRadius: "4px"
      },
      suffix: {
        borderEndEndRadius: "4px",
        borderStartEndRadius: "4px"
      },
      prefixSuffixValidity: {
        borderWidth: 1
      },
      border: {
        borderRadius: 4,
        borderWidth: 1,
        borderColor: theme.colors.baseContrast030
      },
      inputWithValue: {
        padding: "".concat(theme.spacing.base, "px ").concat(theme.spacing.base * 1.5, "px"),
        borderWidth: 1
      },
      inputWithValidValue: {
        "&:focus-visible": {
          borderColor: theme.colors.success
        }
      },
      inputWithInvalidValue: {
        "&:focus-visible": {
          borderColor: theme.colors.alert
        }
      },
      label: {
        color: theme.colors.baseContrast060,
        fontSize: _TextInput.vars.get("labelFontSize", theme.typography.fontSize + 1)
      },
      icon: {
        "& > svg": {
          fill: theme.colors.baseContrast050
        }
      },
      inputHasPrefix: {
        borderInlineStartColor: theme.colors.baseContrast080,
        "&:focus-visible": {
          borderInlineStartColor: theme.colors.baseContrast080
        }
      },
      inputHasSuffix: {
        borderInlineEndColor: theme.colors.baseContrast080,
        "&:focus-visible": {
          borderInlineEndColor: theme.colors.baseContrast080
        }
      }
    };
  }
};
var _default = exports.default = TextInput;